import React, { ReactNode } from 'react';
import { CSSProperties } from 'styled-components';

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  id?: string;
  className?: string;
  children: ReactNode;
  style?: CSSProperties;
}

const Row = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div className={`row ${className || ''}`} ref={ref} {...rest}>
      {props.children}
    </div>
  );
});

export default Row;
